import axios from "axios";
import { StoreAuth } from "@/store/store.auth";
import { GetSelfSystemPermissionsAPI } from "./ProfileAPI/PermissionsAPI/SystemPermissionsAPI/GetSystemSelfPermissions.api";
import { QueryClient } from "@tanstack/react-query";

export function decodeTokenExpiration(token: string) {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));

    const exp = payload.exp;

    if (!exp) {
      return null;
    }

    const expirationDate = new Date(exp * 1000);

    const tehranTime = new Intl.DateTimeFormat("en-GB", {
      timeZone: "Asia/Tehran",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    }).format(expirationDate);

    return {
      payload,
      exp,
      expirationDate,
      tehranTime,
    };
  } catch {
    return null;
  }
}

export const axiosInstance = axios.create({
  baseURL: "https://donya.devtechco.ir/api",
});

axiosInstance.interceptors.request.use((config) => {
  const token = StoreAuth.getState().token;

  if (token && token !== "__next_hmr_refresh_hash__") {
    config.headers.Authorization = ` ${token}`;
  }

  return config;
});

const queryClient = new QueryClient();

axiosInstance.interceptors.response.use(
  (response) => {
    const newToken = response.headers["token"];

    if (newToken && newToken !== "__next_hmr_refresh_hash__") {
      StoreAuth.getState().setToken(newToken);
    }

    return response;
  },

  async (error) => {
    const status = error?.response?.status;

    if (status === 401) {
      StoreAuth.getState().removeToken();

      window.location.replace("/login");

      return Promise.reject(error);
    }

    if (
      status === 403 &&
      !error.config?.url?.includes("/permissions/system/self")
    ) {
      await queryClient.fetchQuery({
        queryKey: ["self-system-permissions"],
        queryFn: GetSelfSystemPermissionsAPI,
      });
    }

    return Promise.reject(error);
  },
);
